import { EventBus, EventTypes } from '../../consts/const-event-types';

export default class JumpToComponent {
  constructor(element) {
    this.el = element
  
    this.jumpTo = this.el; 
    this.jumpToElements = document.querySelectorAll("[data-jump-to]");

    this.currentJumpToNavValue = null;
    this.nodes = null;

    // Functions
    this.init()
  }



  init()
  { 
    this.render();
  }

  render()
  {
    const list = [...document.querySelectorAll("[data-jump-to]")];

    if(list)
    {
      // Create static salary legend
      this.jumpTo.innerHTML = 
      `<ul>   
      ${list.map((l, index) => `<li role="button" tabindex="0" arial-label="Gå til ${l.getAttribute("data-jump-to")}" data-value="${l.getAttribute("data-jump-to")}"><span class="text-box"><span class="text">${l.getAttribute("data-jump-to")}</span></span><span class="number">${index + 1}</span></li>`).join('')} 
      </ul>
      `;

      // If JS-components are needed runtime, instantiate them manually:
      this.nodes = [...this.el.querySelectorAll('[data-value]')];

      if(this.nodes)
      {
        // Add Scroll event listener
        var timer;

        document.addEventListener('scroll', () => 
        {
          if(timer) clearTimeout(timer);
          
          timer = setTimeout(() => { this.updateJumpToNavPosition(); }, 3)
        });

        // set st
        this.updateJumpToNavPosition();

        // Add event click listener
        this.nodes.forEach((node, idx) => 
        {
          node.addEventListener("click", () => 
          {
            var value = node.getAttribute("data-value");
            this.scrollToElement(value);
          });
        });
      } 
    }
  }

  updateJumpToNavPosition()
  {
    this.jumpToElements.forEach(j => 
    {
      var buffer = 20;
      var rect = j.getBoundingClientRect();
      var jTop = window.scrollY + rect.top - buffer;
      var jBottom = window.scrollY + rect.bottom;

      if (window.scrollY >= jTop && window.scrollY <= jBottom)
      {
        //console.log("inside", window.scrollY, jTop, jBottom, j);
        var jumpToNavValue = j.getAttribute("data-jump-to");
        
        if(jumpToNavValue && jumpToNavValue != this.currentJumpToNavValue)
        {
          // reset others
          this.nodes.forEach(n => { n.classList.remove("selected") });

          var selectedNav =  this.el.querySelector(`[data-value='${jumpToNavValue}']`);
          
          if(selectedNav)
          {
            selectedNav.classList.add("selected");
          
            this.currentJumpToNavValue = jumpToNavValue; 
          }
        }
      }
    }) 
  }

  scrollToElement(value)
  {
    this.jumpToElements.forEach(j => 
    {
      if(j.getAttribute("data-jump-to") == value)
      {
        j.scrollIntoView({ behavior: 'smooth', block: 'start'});
      }
    })
  }
}
